import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { AddOrUpdateRewardRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { AddOrUpdateRewardResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const addOrUpdateReward = (request: AddOrUpdateRewardRequest, options?: CashRequestOptions) =>
  post<AddOrUpdateRewardRequest, AddOrUpdateRewardResponse>('/2.0/cash/add-or-update-reward', request, {
    ...options,
    rejectOnError: true,
  })
